import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the ApiUserProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiUserProvider {
  public ClinicID="1";
  public ISDoctor:boolean=false;
  //public ISNurse:boolean=false;
  public USerial:string = "";
  public UName:string = "";
  public UFullName:string = "";
  public MyDomain:string ="https://clinicapi.soft-planning.com";//"http://localhost:50452";//"http://nd.soft-planning.com"; //"http://localhost:50452";
  public MyTestDomain:string = "http://localhost:1622";
  constructor(public http: HttpClient) {
    console.log('Hello ApiUserProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-user/api-user.ts